// component with a material-ui IconButton to emit an event to update the user guarantee
import React from 'react'
import { IconButton } from '@mui/material'
import SyncIcon from '@mui/icons-material/Sync'

const UpdateUserGuarantee = (props) => {
  const { visible, onClick, disabled } = props

  if (visible) {
    return (
      <IconButton onClick={onClick} disabled={disabled} sx={{ padding: 0 }}>
        <SyncIcon sx={{ fontSize: 18, mb: 0.2 }} />
      </IconButton>
    );
  } else {
    return null
  }
}
export default UpdateUserGuarantee
